import { IsUUID, IsString, IsNotEmpty } from 'class-validator';

export class CommentEditDTO {

    @IsNotEmpty()
    @IsString()
    content: string;

    @IsNotEmpty()
    @IsUUID()
    messageId: string;

}
